import {
  ActionType,
  IMentalCheckTypeInfoResponse,
  TypeInfoData,
} from "models/mentalHealth/typeInformation";

export const mentalCheckTypeInfoAction = (payload: TypeInfoData) => {
  return {
    type: ActionType.MENTAL_CHECK_TYPE_INFO,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.MENTAL_CHECK_TYPE_INFO_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IMentalCheckTypeInfoResponse) => {
  return {
    type: ActionType.MENTAL_CHECK_TYPE_INFO_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.MENTAL_CHECK_TYPE_INFO_RESET_DATA,
  };
};
